// src/api.js
import axios from 'axios';

let routerInstance = null;

export const setRouter = (router) => {
  console.log('Setting router instance');
  routerInstance = router;
};

const api = axios.create({
  baseURL: 'https://cambro.fyi/storesafe/',
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(config => {
console.log('Original URL:', config.url);
  return config;
});

api.interceptors.response.use(
  response => {
    console.log(`API Response: ${response.config.method.toUpperCase()} ${response.config.url}`, 
      { status: response.status, data: response.data });
    return response;
  },
  error => {
    console.error('API Response Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });

    if (error.response?.status === 401 && routerInstance) {
      console.log('Unauthorized access, redirecting to login');
      routerInstance.push('/login');
    }
    return Promise.reject(error);
  }
);

// Auth methods
export const auth = {
  login: async (email, password) => {
    console.log('Attempting login for:', email);
    try {
      const response = await api.post('/api/auth/login/', { email, password });
      console.log('Login successful:', {
        isAuthenticated: true,
        userId: response.data.user?.id,
        timestamp: new Date().toISOString()
      });
      return response.data;
    } catch (error) {
      console.error('Login failed:', {
        status: error.response?.status,
        message: error.response?.data?.error || error.message,
        timestamp: new Date().toISOString()
      });
      throw error;
    }
  },

  logout: async () => {
    console.log('Attempting logout');
    try {
      const response = await api.post('/api/auth/logout/'); // Updated path
      console.log('Logout successful');
      return response.data;
    } catch (error) {
      console.error('Logout failed:', error);
      throw error;
    }
  },

  checkAuth: async () => {
    console.log('Checking authentication status');
    try {
      const response = await api.get('/api/auth/check-auth/');
      console.log('Auth check result:', {
        isAuthenticated: response.data.isAuthenticated,
        user: response.data.user,
        timestamp: new Date().toISOString()
      });
      
      return {
        isAuthenticated: response.data.isAuthenticated,
        user: response.data.user || null
      };
    } catch (error) {
      console.error('Auth check failed:', {
        error: error.message,
        timestamp: new Date().toISOString()
      });
      return {
        isAuthenticated: false,
        user: null,
        error: error.message,
        timestamp: new Date().toISOString()
      };
    }
  }
};

console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('Base URL will be:', process.env.NODE_ENV === 'production' ? 'production URL' : 'http://localhost:3001/storesafe');


export default api;